module.exports = __webpack_public_path__ + "static/media/logout.6e68d6b1.svg";